module.exports = __webpack_public_path__ + "img/skridsko_tre.b3f6ee39.jpg";